<template>
  <div class="mt-10">
    <div class="d-flex align-center justify-space-between">
      <div class="flex-1">
        <div class="text-4">Migration</div>

        <div class="mt-4">
          <div
            class="d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-2 px-md-6 py-2"
          >
            <div class="flex-2">Chain</div>
            <div class="flex-3 text-right">Address</div>
            <div class="flex-1"></div>
            <div class="flex-3 text-right">Available</div>
          </div>
          <div class="mt-4 d-flex align-center px-2 px-md-6 text-5">
            <div class="flex-2">Ethereum</div>
            <div class="flex-3 text-right">
              {{ secondaryAddress }}
            </div>
            <div class="flex-1">
              <v-icon v-if="secondaryAddress"
                class="close-icon clickable ml-4 warning--text"
                small
                @click="disconnectWallet"
                >mdi-close</v-icon
              ></div>
            <div class="flex-3 text-right text-uppercase">
              <div>
                <span>
                  {{
                    availableBalance
                      | denomFormat
                  }}</span
                >
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                    availableBalance)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-12 d-none d-md-block" style="width:160px">
        <div>
          <c-btn
            @click="connectEthAddress"
            class="text-center"
          >Connect {{ secondaryAddress ? 'New' : 'ETH' }} Address</c-btn>
        </div>
        <get-address
          v-if="fetchEthAddress && !errorConnecting"
          :wallet="metamaskWallet"
          :project="projectSelected"
          @onAddressSelected="onAddressSelected"
          @onError="onError"
        />
        <div>
          <c-btn
            class="width-100 mt-4"
            is-secondary
            :disabled="disableMigrateButton"
            @click="goToTx('migrate')"
            >Migrate</c-btn
          >
        </div>
      </div>
    </div>
    <div class="mt-4 d-flex align-center px-6 text-5">
      <div class="flex-1" v-if="secondaryAddress">
        <a
          href="https://bridge.dydx.trade/"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-underline-hover"
          >Checkout Pending Migrations on dYdX official bridge page</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PROJECTS from "@/common/config/projects";
import WALLETS from "@/common/config/wallets";
import GetAddress from "@/components/wallet/GetAddress";

export default {
  components: {
    GetAddress,
  },
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
      availableBalanceState: "staking/dydx/availableBalance",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      walletSelected: "userWallets/walletSelected",
      secondaryWalletSelected: "userWallets/secondaryWalletSelected",
      walletCreation: "userWallets/walletCreation",
      walletList: "userWallets/walletList",
    }),
    errorCreating() {
      return this.walletCreation?.error;
    },
    availableBalance() {
      return this.availableBalanceState?.result?.balance
    },
    disableMigrateButton() {
      return (+this.availableBalance === 0) || !this.secondaryWalletSelected
    },
    secondaryAddress() {
      return this.secondaryWalletSelected?.address;
    }
  },
  data: () => ({
    metamaskWallet: WALLETS.find(w => w.name === "metamask"),
    projectSelected: PROJECTS.find(p => p.name === "dydx"),
    fetchEthAddress: false,
    errorConnecting: null,
  }),
  methods: {
    goToTx(type) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { type, action: "tx" },
      });
    },
    async onAddressSelected(address, metadata) {
      this.addressSelected = address;
      if (!this.isAuthenticated) {
        await this.$store.dispatch("auth/guestLogin");
      }
      if (address === this.secondaryWalletSelected.address) {
        return this.$store.dispatch("addAlert", {
          type: "success",
          title: "Success",
          message: "Your ETH wallet is already connected.",
        });
      }
      await this.$store.dispatch("userWallets/addWallet", {
        accountLabel: "Metamask " + address.slice(-4),
        accountType: 'metamask',
        address: address,
        network: 'ethereum',
        metadata: {
          ...metadata,
          isDydxBridge: true,
        },
      });
      if (!this.errorCreating) {
        this.$store.dispatch("addAlert", {
          type: "success",
          title: "Success",
          message: "Your ETH wallet has successfully connected.",
          timeout: 2000,
        });
        const newWallet = this.walletList.result.find(
          (w) => w.address.toLowerCase() === address.toLowerCase()
        );
        this.$store.dispatch("userWallets/setSecondaryWallet", newWallet);
      } else {
        this.$store.dispatch("addAlert", {
          type: "error",
          title: "Error",
          message: "Something went wrong!",
        });
      }
    },
    async disconnectWallet() {
      console.log('wallet', this.secondaryWalletSelected);
      this.$store.dispatch("userWallets/disconnectSecondWallet", this.secondaryWalletSelected.id);
      this.$store.dispatch("staking/dydx/resetState");
      this.$store.dispatch("addAlert", {
          type: "success",
          title: "Success",
          message: "Your ETH wallet is disconnected",
          timeout: 1000,
        });
    },
    connectEthAddress() {
      this.fetchEthAddress = true;
    },
    onError(error) {
      this.errorConnecting = error;
    },
  },
  watch: {
    ["walletList.result"]: {
      immediate: true,
      async handler(list) {
        if (!this.walletList.result) {
          return null;
        }
        const dydxWallet = this.walletList.result.find(w => w.metadata && w.metadata.isDydxBridge);
        if (dydxWallet) {
          this.$store.dispatch("userWallets/setSecondaryWallet", dydxWallet);
        }
        this.fetchEthAddress = false;
      }
    }
  },
};
</script>
